import axios from 'axios';

export async function getSettings(uid: string | null = null) {
	return new Promise(resolve => {
		// Build WP REST URL
		const restUrl = process.env.VUE_APP_WORDPRESS_API + 'vue-events-plugin/v1/settings/' + (uid ? '?uid=' + uid : '')

		// Make request to get the menu data
		const ax = axios.get(restUrl)
			.then((response) => {
				// Append new item to the array
				if (response.data) {
					return resolve(response.data);
				}

				return resolve(false);
			})
			.catch(() => {
				return resolve(false);
			})

		return ax;
	});
}
